import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateFormatService, LocaleDateFormat, DateValue } from '../services/date-format.service';

@Pipe({
	name: 'localeDate',
	standalone: true,
	pure: false,
})
export class LocaleDatePipe implements PipeTransform {
	private readonly dateFormatService: DateFormatService = inject(DateFormatService);

	transform(
		value: DateValue,
		mode: LocaleDateFormat = 'date',
		customOptions?: Intl.DateTimeFormatOptions
	): string {
		return this.dateFormatService.formatDate(value, mode, customOptions);
	}
}